import type { PropsWithChildren } from "react";

export const RightSlot = ({ children }: Readonly<PropsWithChildren>) => (
  <div
    className="flex min-w-0 items-center justify-end gap-2"
    data-testid="header-v4-right-slot"
  >
    {children}
  </div>
);

RightSlot.displayName = "HeaderWrapper.RightSlot";
